import { useState } from 'react'

import classNames from 'classnames'

import getFileUrl from 'core/application/commons/fileStorage/getFileUrl'
import { ExpenseTypeEligibility } from 'core/domain/expenses/expenseTypeEligibility'

import { queryRequest } from 'common/RequestUtils'
import { Col, Icon, Modal, Notification, Row } from 'common/components'
import { formatDateTimeAMPM } from 'common/dateFormatters'

interface DocumentProps {
  documents: any[]
  expenseTypeEligibility?: ExpenseTypeEligibility
}
const getDocumentUrl = async (filename: string) => {
  const result = await queryRequest(() => getFileUrl(filename))
  if (!result.errors) {
    return result
  } else {
    Notification.open({
      type: 'error',
      message: result.errors[0].message,
    })
    return ''
  }
}

const DocumentComponent = ({ documents, expenseTypeEligibility }: DocumentProps) => {
  const [extractedData, setExtractedData] = useState<string | null>('')

  const hasExtractedData = (document) =>
    document.extractExpenseDataFromFile && document.extractExpenseDataFromFile.items.length > 0

  return (
    <>
      <div>
        {expenseTypeEligibility === ExpenseTypeEligibility.ReimbursableWithDoctorsNote && (
          <div className={'text-bold mb-8'}>
            <i className="far fa-user-md mr-8" aria-hidden="true"></i>
            <span>Requires Doctor's Note</span>
          </div>
        )}
        {documents &&
          documents.map((document, index) => {
            return (
              <Row
                className={classNames('color-green-6 w-100', index !== documents.length - 1 && 'mb-32')}
                align={'top'}
                key={document.id}
                gutter={16}
              >
                <Col span={hasExtractedData(document) ? 9 : 24} className={'align-start break-word'}>
                  <a
                    style={{ wordWrap: 'break-word', verticalAlign: 'top' }}
                    onClick={async (e) => {
                      e.stopPropagation()
                      const documentUrl = await getDocumentUrl(document.filename)
                      if (documentUrl) window.open(documentUrl, '_blank')
                    }}
                    target="_blank"
                  >
                    {' '}
                    <Icon type="far fa-paperclip" fontAwesome className="mr-8" />
                    {document.title}
                    {document.createdAt ? `(${formatDateTimeAMPM(document.createdAt)})` : ''}
                  </a>
                </Col>

                {hasExtractedData(document) && (
                  <Col span={15}>
                    <>
                      <Row className={'color-gray-10'}>
                        <Col span={24}>
                          <b>Date of Service Match:</b> {document.dateOfServiceMatch ? 'Yes' : 'No'}
                        </Col>
                      </Row>
                      <Row className={'color-gray-10'}>
                        <Col span={24}>
                          <b>Amount submitted Match:</b> {document.amountSubmittedMatch ? 'Yes' : 'No'}
                        </Col>
                      </Row>
                      <Row className={'color-gray-10'}>
                        <Col span={24}>
                          <b>Rx: </b> {document.extractExpenseDataFromFile.items[0].rx.length > 0 ? 'Yes' : 'No'}
                        </Col>
                      </Row>
                      {document.duplicatedExpenseNumber ? (
                        <Row className={'mb-16 color-gray-10'}>
                          <Col span={24}>
                            <b>Duplicate: {document.duplicatedExpenseNumber}</b>
                          </Col>
                        </Row>
                      ) : (
                        <Row className={'mb-16 color-gray-10'}>
                          <Col span={24}>
                            <b>No Duplicate</b>
                          </Col>
                        </Row>
                      )}
                      {/*{document.extractExpenseDataFromFile.items.map((item) => (*/}
                      {/*  <Row className={'color-gray-10 mt-16'}>*/}
                      {/*    /!*<Col span={24}>*!/*/}
                      {/*    /!*  <b>*!/*/}
                      {/*    /!*    {item.receiptNumber} of Receipts:{' '}*!/*/}
                      {/*    /!*    {document.extractExpenseDataFromFile.totalNumberOfReceipts}, {item.pageNumber} of pages:{' '}*!/*/}
                      {/*    /!*    {document.extractExpenseDataFromFile.totalNumberOfPages}*!/*/}
                      {/*    /!*  </b>*!/*/}
                      {/*    /!*</Col>*!/*/}
                      {/*    {item.vendor && (*/}
                      {/*      <Col span={24}>*/}
                      {/*        <b>Vendor:</b> {item.vendor} ({item.vendorConfidence}%)*/}
                      {/*      </Col>*/}
                      {/*    )}*/}
                      {/*    {item.otherVendors &&*/}
                      {/*      item.otherVendors.map((v) => (*/}
                      {/*        <Col span={24}>*/}
                      {/*          <b>Vendor:</b> {v.label} - {v.value}*/}
                      {/*        </Col>*/}
                      {/*      ))}*/}
                      {/*    {item.amountPaid && (*/}
                      {/*      <Col span={24}>*/}
                      {/*        <b>Amount Paid:</b> {item.amountPaid} ({item.amountPaidConfidence}%)*/}
                      {/*      </Col>*/}
                      {/*    )}*/}
                      {/*    {item.otherAmounts &&*/}
                      {/*      item.otherAmounts.map((v) => (*/}
                      {/*        <Col span={24}>*/}
                      {/*          <b>Total:</b> {v.label} - {v.value}*/}
                      {/*        </Col>*/}
                      {/*      ))}*/}
                      {/*    {item.receiverName && (*/}
                      {/*      <Col span={24}>*/}
                      {/*        <b>Receiver Name:</b> {item.receiverName} ({item.receiverNameConfidence}%)*/}
                      {/*      </Col>*/}
                      {/*    )}*/}
                      {/*    {item.otherReceiverNames &&*/}
                      {/*      item.otherReceiverNames.map((v) => (*/}
                      {/*        <Col span={24}>*/}
                      {/*          <b>Receiver Name:</b> {v.label} - {v.value}*/}
                      {/*        </Col>*/}
                      {/*      ))}*/}
                      {/*    {item.otherNames &&*/}
                      {/*      item.otherNames.map((v) => (*/}
                      {/*        <Col span={24}>*/}
                      {/*          <b>Name:</b> {v.label} - {v.value}*/}
                      {/*        </Col>*/}
                      {/*      ))}*/}
                      {/*    {item.invoiceReceiptDate && (*/}
                      {/*      <Col span={24}>*/}
                      {/*        <b>Invoice Receipt Date:</b> {item.invoiceReceiptDate} (*/}
                      {/*        {item.invoiceReceiptDateConfidence}%)*/}
                      {/*      </Col>*/}
                      {/*    )}*/}
                      {/*    {item.otherDates &&*/}
                      {/*      item.otherDates.map((v) => (*/}
                      {/*        <Col span={24}>*/}
                      {/*          <b>Date of Service:</b> {v.label} - {v.value}*/}
                      {/*        </Col>*/}
                      {/*      ))}*/}
                      {/*    {item.hsa &&*/}
                      {/*      item.hsa.map((v) => (*/}
                      {/*        <Col span={24}>*/}
                      {/*          <b>HSA item:</b> {v.label} - {v.value}*/}
                      {/*        </Col>*/}
                      {/*      ))}*/}
                      {/*    {item.rx &&*/}
                      {/*      item.rx.map((v) => (*/}
                      {/*        <Col span={24}>*/}
                      {/*          <b>RX item:</b> {v.label} - {v.value}*/}
                      {/*        </Col>*/}
                      {/*      ))}*/}
                      {/*  </Row>*/}
                      {/*))}*/}
                    </>
                    {/*<Button*/}
                    {/*  disabled={isExtractDataLoading}*/}
                    {/*  loading={isExtractDataLoading}*/}
                    {/*  onClick={async () => {*/}
                    {/*    const documentUrl = await getDocumentUrl(document.filename)*/}
                    {/*    const response = await sendGetExtractedData(() =>*/}
                    {/*      extractTextFromInvoice(encodeURIComponent(documentUrl)),*/}
                    {/*    )*/}
                    {/*    if (response) setExtractedData(response.text)*/}
                    {/*  }}*/}
                    {/*>*/}
                    {/*  View extracted Data*/}
                    {/*</Button>*/}
                  </Col>
                )}
              </Row>
            )
          })}

        {documents && documents.length > 1 && (
          <>
            <div className="flex flex__align_center color-green-6 mt-24">
              <Icon type="far fa-paperclip" fontAwesome className="mr-8" />
              <div>
                <a
                  onClick={async (e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    Promise.allSettled(
                      documents.map(async (document) => {
                        return await getDocumentUrl(document.filename)
                      }),
                    ).then((values) => {
                      values.forEach((documentUrl) => {
                        if (documentUrl.status === 'fulfilled') {
                          window.open(documentUrl.value, '_blank')
                        }
                      })
                    })
                  }}
                  target="_blank"
                >
                  View All
                </a>
              </div>
            </div>
          </>
        )}
      </div>

      <Modal
        width={'720px'}
        title={'Extracted data'}
        onCancel={() => setExtractedData(null)}
        onOk={() => setExtractedData(null)}
        visible={!!extractedData}
      >
        <pre>{extractedData}</pre>
      </Modal>
    </>
  )
}

export default DocumentComponent
